import React, { useState } from "react";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/styles";
import InputBase from "@mui/material/InputBase";

// const useStyles = makeStyles({
//   root: {
//     borderRadius: 22,
//     border: "1px solid #ced4da",
//     fontSize: 12,
//     width: 240,
//     padding: "4px 4px 4px 12px",
//   },
// });

const InputBox = (props) => {
  const { id, name, type, placeholder, onChange, className, value } = props;
  // const classes = useStyles();

  return (
    <InputBase
      id={id}
      name={name}
      type={type}
      variant="outlined"
      placeholder={placeholder}
      value={value}
      // className={classes.root}
      onChange={onChange}
      autocomplete="off"
    />
  );
};
export default InputBox;
